import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { initGA, trackPageView } from './Components/Utils/analytics';
import { useTokenRefresh } from './Components/Utils/useTokenRefresh';
import SessionWarning from './Components/Utils/SessionWarning';
import LandingPage from './Components/LandingPage/LandingPage';
import Registration from './Components/Registration/Registration';
import Login from './Components/Login/Login';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import SuggestedProfiles from './Components/SuggestedProfiles/SuggestedProfiles';
import ProfileImageUpload from './Components/ProfileImageUpload/ProfileImageUpload';
import Home from './Components/Home/Home';
import Search from './Components/Search/Search';
import ViewProfile from './Components/ViewProfile/ViewProfile';
import EditProfile from './Components/EditProfile/EditProfile';
import About from './Components/About/About';
import Services from './Components/Services/Services';
import Testimonials from './Components/Testimonials/Testimonials';
import Blog from './Components/Blog/Blog';
import Contact from './Components/Contact/Contact';
import AccountDeletionPolicy from './Components/Policies/AccountDeletionPolicy';
import ChildSafetyPolicy from './Components/Policies/ChildSaffetyPolicy';
import ConsentPolicy from './Components/Policies/ConsentPolicy';
import ContentPolicy from './Components/Policies/ContentPolicy';
import CustomerServicePolicy from './Components/Policies/CustomerServicePolicy';
import LegalCompliance from './Components/Policies/LegalCompliance';
import PrivacyPolicy from './Components/Policies/PrivacyPolicy';
import ReviewPolicy from './Components/Policies/ReviewPolicy';
import SecurityPolicy from './Components/Policies/SecurityPolicy';
import TermsAndConditions from './Components/Policies/TermsAndConditions';
import FAQ from './Components/Policies/FAQ';
import SafetyTips from './Components/Policies/SafetyTips';
import CookiePolicy from './Components/Policies/CookiePolicy';
import PrivacySettings from './Components/Policies/PrivacySettings';
import AllPolicies from './Components/Policies/AllPolicies';
import Chat from './Components/Chat/Chat';
import PaymentSuccess from './Components/PayPal/PaymentSuccess';
import PayPalPayment from './Components/PayPal/PaypalPayment';
import PaymentCancel from './Components/PayPal/PaymentCancel';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

const TokenRefreshWrapper = () => {
  const { showWarning, minutesRemaining, handleStayLoggedIn, handleLogout } = useTokenRefresh();

  return (
    <>
      {showWarning && (
        <SessionWarning
          minutesRemaining={minutesRemaining}
          onStayLoggedIn={handleStayLoggedIn}
          onLogout={handleLogout}
        />
      )}
    </>
  );
};

const App = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <AnalyticsTracker />
      <TokenRefreshWrapper />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/upload-profile-image" element={<ProfileImageUpload />} />
        <Route path="/home" element={<Home />} />
        <Route path="/suggestedprofiles" element={<SuggestedProfiles />} />
        <Route path="/search" element={<Search />} />
        <Route path="/profile/:id" element={<ViewProfile />} />
        <Route path="/editprofile" element={<EditProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/all-policies" element={<AllPolicies />} />
        <Route path="/accountdeletion" element={<AccountDeletionPolicy />} />
        <Route path="/childsafety" element={<ChildSafetyPolicy />} />
        <Route path="/consent" element={<ConsentPolicy />} />
        <Route path="/content" element={<ContentPolicy />} />
        <Route path="/customerservice" element={<CustomerServicePolicy />} />
        <Route path="/legalcompliance" element={<LegalCompliance />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/review" element={<ReviewPolicy />} />
        <Route path="/security" element={<SecurityPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/safety-tips" element={<SafetyTips />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/privacy-settings" element={<PrivacySettings />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/paypal-payment" element={<PayPalPayment />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
      </Routes>
    </Router>
  );
}

export default App;
